import React, { useEffect, useState } from "react";
import styles from "./pduis.module.css";
import Layout from "../../components/layout/layout";
import { useNavigate } from "react-router-dom";
import ViewSelector from "./components/view_selector/view_selector";
import Table from "../../components/ajonjolib/table/table";
import StatusPill from "../../components/status_pill/status_pill";
import axiosInstance from "../../AxiosInstance";
import { openModal } from "../../components/ajonjolib/toasts/toast/toast";
import OutputStatesModal from "../detail/modals/output_states";
import { formatTimestamp, pduiIsReady } from "../../utils/utils";
import { FiEdit } from "react-icons/fi";
import EditPduiModal from "../detail/modals/edit_pdui_name";
import StatusDot from "../../components/status_dot";
import Loader from "../../components/loader/loader";
import { useTranslation } from 'react-i18next';

function PduiBox({ selected, data, setSelectedId }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);

  const details = () => {
    navigate(`/detail/${data.id}/`);
  };

  useEffect(() => {
    const lastHeartbeat = data?.last_heartbeat;
    if (lastHeartbeat) {
      setIsActive(pduiIsReady(lastHeartbeat));
    }
  }, [data]);

  const onEdit = async (event) => {
    event.stopPropagation();
    setSelectedId(data.id);
  };

  return (
    <div>
      <div
        className={`${styles.pduiContainer} ${selected ? styles.selected : ""}`}
        onClick={() => details()}
      >
        <div className={styles.edit} onClick={onEdit}>
          <FiEdit size={13} />
        </div>
        <div className={styles.pduiName}>{data?.name}</div>
        <div className={styles.divider} />
        <div className={styles.pduiDetails}>
          <div className={"d-flex justify-content-between"}>
            <div style={{ fontWeight: "bold" }}>{t('pduis.lastConnShort')}</div>
            <div style={{ fontWeight: "lighter" }}>
              {formatTimestamp(data.updated_at)}
            </div>
          </div>
          <div className={"d-flex align-items-center gap-1"}>
            <div style={{ fontWeight: "bold" }}>{t('pduis.status')}</div>
            <StatusDot isReady={isActive} />
          </div>
        </div>
      </div>
    </div>
  );
}

function PduiItemView({ data, setSelectedId }) {
  return (
    <div className="d-flex flex-wrap">
      {data?.map((entry) => {
        return (
          <PduiBox key={entry.id} data={entry} setSelectedId={setSelectedId} />
        );
      })}
    </div>
  );
}

function PduiListView({ data }) {
  const { t } = useTranslation();
  const cols = [
    {
      title: t('pduis.name'),
      key: "name",
      code: (row, data) => {
        return <div style={{ color: "#ED8B00", fontWeight: 600 }}>{data}</div>;
      },
    },
    { title: t('pduis.model'), key: "model.name" },
    { title: t('pduis.internalId'), key: "reference" },
    { title: t('pduis.ip'), key: "ipv4" },
    {
      title: t('pduis.lastConnShort'),
      key: "updated_at",
      code: (row, data) => {
        return formatTimestamp(data);
      },
    },
    {
      title: t('pduis.status'),
      key: "updated_at",
      code: (row, data) => {
        let active = false;
        let now = new Date();
        let lastActivity = new Date(data);
        let diff = (now - lastActivity) / 1000;
        if (diff < 60) {
          active = true;
        }
        return <StatusPill value={active} />;
      },
    },
  ];

  return <Table model={"pdui"} cols={cols} />;
}

export default function Pduis() {
  const [viewType, setViewType] = useState("items");
  const [data, setData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axiosInstance.get("pdui/").then((response) => {
      if (response?.status !== 200) {
        return;
      }
      setData(response.data);
    }).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (selectedId) {
      const match = data.find((pdui) => pdui.id === selectedId);
      if (match) {
        openModal(`edit_pdui_${selectedId}`, { selectedId, pduiName: match.name });
      }
    }
  }, [selectedId]);

  return (
    <div className={styles.container}>
      {loading && <Loader />}
      <EditPduiModal id={selectedId} setSelectedId={setSelectedId} />
      <Layout selectedIndex={1}>
        <OutputStatesModal />
        <div className={"d-flex"}>
          <ViewSelector setViewType={setViewType} viewType={viewType} />
          <div className={"flex-grow-1"}>
            {viewType === "items" ? (
              <PduiItemView data={data} setSelectedId={setSelectedId} />
            ) : (
              <PduiListView data={data} />
            )}
          </div>
        </div>
      </Layout>
    </div>
  );
}
